/**
 * Pure decision helper for the Start/Continue Task button on the Work Items
 * Dashboard. Given a row and the current operator's Amazon login, decides
 * whether the click handler must reassign the task (via UpdateWorkItemState
 * with `status = ACTIVE`) before navigating to the detail page.
 *
 * A reassignment is required when:
 *   - the row has no operator assigned (empty or whitespace-only), or
 *   - the current operator login is unknown (empty or whitespace-only), or
 *   - the row's operator does not match the current operator login.
 *
 * Pure — no React, no Redux, no network imports.
 */

import type { WorkItemSummary } from "./model";

export const shouldReassignOperator = (
  row: Pick<WorkItemSummary, "operator">,
  currentOperatorLogin: string | null | undefined,
): boolean => {
  const rowOp = row.operator?.trim() ?? "";
  const me = currentOperatorLogin?.trim() ?? "";
  if (rowOp === "") return true;
  if (me === "") return true;
  return rowOp !== me;
};
